import type { MFAErrorCodes } from './MFAErrorCodes';

export class MFAError extends Error {
  /**
   * this is necessary for connect as for somereason prototype chain on errors is broken
   * in reconnect the `error instanceof MFAError` part would return true no issues and the whole other check won't ever be executed
   * in connect however it would return false even for MFAError instances then the whole other check is necessary to identify MFAErrors correctly
   */
  static isMFAError(error: unknown): error is MFAError {
    return (
      error instanceof MFAError ||
      Boolean(
        error &&
          typeof error === 'object' &&
          'name' in error &&
          typeof error.name === 'string' &&
          error.name.includes('MFAError'),
      )
    );
  }

  constructor(
    message: string,
    public code: MFAErrorCodes,
  ) {
    super(`MFA Error: ${message} (${code})`);
    this.name = 'MFAError';
  }
}

type ConnectErrorDetail = {
  name: string;
};

export class XHRMFAError extends MFAError {
  public serverErrorName: string;
  public serverErrorAction: string;
  public errors: ConnectErrorDetail[];
  public additionalData: Record<string, unknown>;

  constructor(otpError: MFAError) {
    super(otpError.message, otpError.code);
    this.name = 'MFAError(XHR)';

    this.serverErrorName = this.name;
    this.serverErrorAction = 'MFA_ERROR';
    this.errors = [
      {
        name: this.name,
      },
    ];
    this.additionalData = {
      serverErrorName: this.serverErrorName,
      serverErrorAction: this.serverErrorAction,
      serverErrorData: this.code,
    };
  }

  get serverErrorData(): string {
    return this.code;
  }
}
